import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import * as SettingsActions from '../../../state/actions/message-settings'
import OpenChairMessage from './OpenChairMessage'
import Help from '../Help'
import HelpButton from '../HelpButton'
import buildTextEditor from '../buildTextEditor'
import { logException } from '../../../services/sentry'
import styles from './styles.css'

const WelcomeEmail = buildTextEditor(OpenChairMessage)
const ConfirmationText = buildTextEditor(OpenChairMessage)

class OpenChairMessageEditor extends React.Component {
  static propTypes = {
    createMessageSetting: PropTypes.func,
    deactivateSetting: PropTypes.func,
    hasPlum: PropTypes.bool,
    maxChars: PropTypes.number.isRequired,
    openchairEmail: PropTypes.shape({
      active: PropTypes.bool.isRequired,
      always_send: PropTypes.bool.isRequired,
      created_at: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      message_setting_type: PropTypes.string.isRequired,
      message_type: PropTypes.string.isRequired,
      offset: PropTypes.number.isRequired,
      practice_id: PropTypes.number.isRequired,
      updated_at: PropTypes.string.isRequired,
    }),
    openchairText: PropTypes.shape({
      active: PropTypes.bool.isRequired,
      always_send: PropTypes.bool.isRequired,
      created_at: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      message_setting_type: PropTypes.string.isRequired,
      message_type: PropTypes.string.isRequired,
      offset: PropTypes.number.isRequired,
      practice_id: PropTypes.number.isRequired,
      updated_at: PropTypes.string.isRequired,
    }),
    pmsType: PropTypes.string,
    pmsVersion: PropTypes.number,
    updateMessageSetting: PropTypes.func,
  }
  constructor(props) {
    super(props)
    this.state = {
      isHelpOpen: false,
    }
  }

  toggleHelp = () => {
    this.setState({ isHelpOpen: !this.state.isHelpOpen })
  }

  updateSetting = ({ body, subject, always_send }) => {
    const { openchairEmail, openchairText } = this.props
    const settingId = subject ? openchairEmail.id : openchairText.id
    const changes = {
      body,
      subject,
      always_send,
    }

    return this.props
      .updateMessageSetting(settingId, changes)
      .then(() => {
        // deactivate confirmation text if left empty
        if (!body.text.trim()) {
          this.props.deactivateSetting(settingId)
        }
      })
      .catch((err) => {
        logException(err)
      })
  }

  createConfirmationText = ({ body, subject, always_send }) => {
    if (body.text.trim()) {
      const initialSetting = {
        active: !!body,
        always_send: false,
        body: '',
        message_type: 'text',
        message_setting_type: 'openchair',
        message_setting_subtype: 'to_patient',
      }
      const changes = {
        body,
        subject,
        always_send,
        offset: 1,
      }
      return this.props
        .createMessageSetting(initialSetting, changes)
        .catch((err) => {
          console.error(err)
        })
    }
    return Promise.resolve('emptyText')
  }

  render() {
    const { isHelpOpen } = this.state
    const {
      hasPlum,
      maxChars,
      openchairEmail,
      openchairText,
      pmsType,
      pmsVersion,
    } = this.props

    return (
      <div className={`${styles.container} CallTextSettingEditor`}>
        <h1>New Patient Messaging</h1>
        <div className="helpButtonContainer">
          <HelpButton onTouchTap={this.toggleHelp} />
        </div>
        {isHelpOpen && (
          <Help
            hasPlum={!!hasPlum}
            hasReviews={false}
            onlyVars
            pmsType={pmsType}
            pmsVersion={pmsVersion}
          />
        )}
        <div className={styles.openChairMessagesWrapper}>
          {openchairEmail && (
            <WelcomeEmail
              key={openchairEmail.id}
              hasPlum={false}
              hasReviews={false}
              isEmail
              maxChars={maxChars}
              pmsType={pmsType}
              pmsVersion={pmsVersion}
              setting={openchairEmail}
              title="Welcome Email"
              updateSetting={this.updateSetting}
            />
          )}
          {openchairText && (
            <ConfirmationText
              key={openchairText.id}
              createSetting={this.createConfirmationText}
              hasPlum={false}
              hasReviews={false}
              maxChars={maxChars}
              pmsType={pmsType}
              pmsVersion={pmsVersion}
              setting={openchairText}
              title="Confirmation Text"
              updateSetting={this.updateSetting}          
            />
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({
  account: {
    auth: { hasPlum, pmsType, pmsVersion },
  },
}) => ({
  hasPlum,
  pmsType,
  pmsVersion,
})

const mapDispatchToProps = {
  updateMessageSetting: SettingsActions.updateMessageSetting,
  createMessageSetting: SettingsActions.createMessageSetting,
  deactivateSetting: SettingsActions.deactivateSetting,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OpenChairMessageEditor)



// WEBPACK FOOTER //
// ./src/components/Settings/OpenChairMessageEditor/index.js